import { combineReducers } from "redux";
import user from "./reducer-user";

export default combineReducers({ 
    user
});
